import Card from "antd/es/card/Card";
import { get } from "lodash";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { BiChevronLeft } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import AdvisorSellerCodeMappingsCard from "shared/components/AdvisorSellerCodeMappingsCard";
import Header from "shared/components/Header";
import { NAME_SPACES } from "shared/locales/constants";
import { StoreContext } from "shared/store";
import { SCREENS } from "utils/constants";

const SellerCodes = () => {
  const { user } = useContext(StoreContext);
  const organizationId = get(user, "organization.id");
  const navigate = useNavigate();
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PRODUCT_RANGE);
  const PAGE = t("SELLER_CODES_PAGE", { returnObjects: true });

  return (
    <>
      <Header
        title={PAGE.TITLE}
        actions={[
          {
            text: PAGE.BACK,
            onClick: () =>
              navigate(SCREENS.PRIVATE.ADMIN.PRODUCT_RANGES.LIST.path),
            type: "primary--outlined",
            icon: <BiChevronLeft size={20} />,
          },
        ]}
      />
      {organizationId ? (
        <Card type="simple">
          <AdvisorSellerCodeMappingsCard
            organizationId={organizationId}
            nameSpace={NAME_SPACES.PRIVATE.ADMIN.PRODUCT_RANGE}
            introMessage={PAGE.INTRO}
            showLabelTooltips
          />
        </Card>
      ) : null}
    </>
  );
};

export default SellerCodes;
